import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import * as fromTemperature from './temperature.reducer';

export interface TemperatureState {
  temperatures: fromTemperature.TemperatureState;
}

export const reducers: ActionReducerMap<TemperatureState> = {
  temperatures: fromTemperature.temperatureReducer,
};

export const selectTemperatureState = createFeatureSelector<fromTemperature.TemperatureState>(
  fromTemperature.inRoomTemperatureFeatureKey
);

export const selectTemperatureIds = createSelector(selectTemperatureState, fromTemperature.selectTemperatureIds);

export const selectTemperatureEntities = createSelector(
  selectTemperatureState,
  fromTemperature.selectTemperatureEntities
);

export const selectAllTemperatures = createSelector(selectTemperatureState, fromTemperature.selectAllTemperatures);

export const selectTemperatureTotal = createSelector(selectTemperatureState, fromTemperature.selectTemperatureTotal);

export const selectCurrentTemperature = createSelector(
  selectTemperatureEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromTemperature.selectTemperatureId(location, room)];
  }
);
